export default __webpack_public_path__ + "static/media/rani-roopmati-mahal.7884e8b1.jpg";